import { render, staticRenderFns } from "./LSGrid.vue?vue&type=template&id=37eb2914"
import script from "./LSGrid.vue?vue&type=script&lang=ts&setup=true"
export * from "./LSGrid.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37eb2914')) {
      api.createRecord('37eb2914', component.options)
    } else {
      api.reload('37eb2914', component.options)
    }
    module.hot.accept("./LSGrid.vue?vue&type=template&id=37eb2914", function () {
      api.rerender('37eb2914', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/LSGrid/LSGrid.vue"
export default component.exports